import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';
import Card from '../../../common/Card';
export const IconTitleContainer = styled.div `
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: center;

  ${media.tablet `
    flex-direction: column;
    gap: 12px;
    align-items: center;
    text-align: center;
  `}
`;
export const CTAsContainer = styled.div `
  width: 100%;
  display: flex;
  justify-content: flex-start;

  ${media.tablet `
    justify-content: center;
  `}
`;
export const DefaultTileContent = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.lg}px;
  width: 100%;
  height: 100%;
`;
export const DefaultTileBody = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.lg}px;
  width: 100%;
`;
export const DefaultCard = styled(Card) `
  height: auto;
  align-self: stretch;

  .card-body {
    padding: 32px 40px;
    padding-bottom: 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  ${media.tablet `
    min-height: 264px;
    height: 100%;
    .card-body {
      padding: 32px 20px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 16px;
    }
  `}
`;
